import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "cart-widget__headline" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "cart-widget__headline-label" }, " Dein Warenkorb ", -1)
const _hoisted_3 = { class: "cart-widget__headline-close" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, " Warenkorb schließen ", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "cart-loader"
}

import {
  computed,
  ref,
  watch,
} from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import AppCartOverview from '@/components/cart/AppCartOverview.vue';
import AppCartItems from '@/components/cart/AppCartItems.vue';
import AppCartItemRemove from '@/components/cart/AppCartItemRemove.vue';
import Product from '@/classes/Product';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faSpinner,
  faXmark,
} from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartWidget',
  setup(__props) {

library.add(faSpinner, faXmark);

const store = useStore();
const router = useRouter();
const root = ref<InstanceType<typeof HTMLElement>>();
const content = ref<InstanceType<typeof HTMLElement>>();
const overview = ref<InstanceType<typeof CartOverview>>();

const itemToRemove = ref<Product | null>(null);
const keyToRemove = ref<string | null>(null);

const toggle = () => {
  store.commit('cart/TOGGLE_SHOW_WIDGET');
};

const show = computed(() => store.getters['cart/showWidget']);
const isLoading = computed(() => store.getters['cart/isLoading']);
const countItemsAll = computed(() => store.getters['cart/countAll']);
const isOrderPage = computed(() => store.getters['page/pageType'] === 'order');
const isOrderCancel = computed(() => countItemsAll.value === 1 && isOrderPage.value);
const orderIsCanceled = computed(() => countItemsAll.value === 0 && isOrderPage.value);

const onItemRemove = (key: string, product: Product) => {
  itemToRemove.value = product;
  keyToRemove.value = key;
};

const onRemoveDecline = () => {
  itemToRemove.value = null;
  keyToRemove.value = null;
};

const onRemoveApproved = () => {
  if (orderIsCanceled.value) {
    router.push('/');
    toggle();
  }
  onRemoveDecline();
};

watch(() => show.value, () => {
  if (!show.value) {
    setTimeout(() => {
      itemToRemove.value = null;
      keyToRemove.value = null;
    }, 475);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["cart-widget__overlay", { show: show.value }])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["cart-widget", { show: show.value }]),
      ref_key: "root",
      ref: root
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            title: "Warenkorb schließen",
            onClick: toggle
          }, [
            _createVNode(_component_FontAwesomeIcon, { icon: "fa-light fa-xmark" }),
            _hoisted_4
          ])
        ])
      ]),
      _createElementVNode("div", {
        ref_key: "content",
        ref: content,
        class: "cart-widget__content"
      }, [
        (itemToRemove.value)
          ? (_openBlock(), _createBlock(AppCartItemRemove, {
              key: 0,
              product: itemToRemove.value,
              "is-order-cancel": isOrderCancel.value,
              "item-key": keyToRemove.value,
              onClear: onRemoveDecline,
              onApproved: onRemoveApproved
            }, null, 8, ["product", "is-order-cancel", "item-key"]))
          : _createCommentVNode("", true),
        (countItemsAll.value === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Dein Warenkorb ist leer "))
          : _createCommentVNode("", true),
        (!itemToRemove.value)
          ? (_openBlock(), _createBlock(AppCartItems, {
              key: 2,
              onRemove: onItemRemove
            }))
          : _createCommentVNode("", true)
      ], 512),
      (countItemsAll.value > 0)
        ? (_openBlock(), _createBlock(AppCartOverview, {
            key: 0,
            ref_key: "overview",
            ref: overview,
            onClose: toggle
          }, null, 512))
        : _createCommentVNode("", true),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "fa-light fa-spinner",
                class: "fa-pulse"
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 64))
}
}

})